import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isEmpty, sortBy } from 'lodash'
import Fuse from 'fuse.js'

import Loader from 'components/Loader'
import Layout from 'components/Layout'

import { useGetAccountsQuery } from 'store/porticoApi/accounts'
import AccountsLayout from 'views/Accounts/Layout/AccountsLayout'
import AccountsFilters from 'views/Accounts/Filters/AccountsFilters'
import { filterAccountsByStatus } from 'utils/accounts/filterAccountsByStatus'
import paginationCoordinator from 'utils/general/paginationCoordinator'
import { extendFuseOptions } from 'utils/search/extendFuseOptions'
import { TAccountWithRoles } from 'types/accounts'

const Accounts = () => {
  const [statusQuery, setSelectStatusQuery] = useState('')
  const [query, setQuery] = useState('')

  const { data: accounts, isFetching: isLoadingAccounts } = useGetAccountsQuery()

  const location = useLocation()
  const navigate = useNavigate()

  const accountsSortedByFirstName = sortBy(accounts, 'firstName')

  const filteredAccountsByStatus = accountsSortedByFirstName
    ? filterAccountsByStatus(statusQuery, accountsSortedByFirstName)
    : []

  const fuseKeys = ['email', 'firstName', 'lastName', 'userRolesNames']

  const fuse = new Fuse(filteredAccountsByStatus ?? [], extendFuseOptions(fuseKeys))

  const filteredAccounts = isEmpty(query)
    ? filteredAccountsByStatus
    : fuse.search(query)?.map((account) => account.item)

  const paginator = paginationCoordinator<TAccountWithRoles>(filteredAccounts, location, navigate)
  const accountsFilteredAndPaginatedResult = paginator?.result

  if (isLoadingAccounts) {
    return <Loader />
  }

  return (
    <Layout
      mainContent={
        <AccountsLayout accounts={accountsFilteredAndPaginatedResult} paginator={paginator} />
      }
      navbarContent={
        <AccountsFilters
          query={query}
          setQuery={setQuery}
          handleChangeSelect={setSelectStatusQuery}
        />
      }
    />
  )
}

export default Accounts
